import { createSelector } from "reselect";

/** @type {() => typeof import("./reducer").initState} */
export const selectRoot = (state) => state.figures;

export const selectAllFilters = createSelector(selectRoot, (root) => root.filters);

export const selectSingleFilter = (filterName) =>
  createSelector(selectRoot, (root) => root.filters[filterName] || undefined);

export const selectFigureFilters = (filters) => {
  const inputSelectorList = [];
  for (const key in filters) {
    const selector = selectSingleFilter(filters[key]);
    inputSelectorList.push(selector);
  }

  return createSelector(inputSelectorList, (...args) => {
    const filterValues = {};
    for (let i = 0; i < args.length; i++) {
      const key = Object.keys(filters)[i];
      filterValues[key] = args[i];
    }
    return filterValues;
  });
};

export const selectHideBlanks = createSelector(selectRoot, (root) => root.hideBlanks || false);
